import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bodySummary: false,
  coverPage: false,
  reportSummary: false,
  testRecommendation: false,
  vizApp: false,
  smartVideoReport: false,
  primaryColor: "#2A7EC5",
  reportType: "dynamic",
  headerBase64: "",
  footerBase64: "",
  logoBase64: "",
  doctorSignBase64: "",
  logoFileName: "",
  letterHeadFileName: "",
  doctorSignFileName: "",
  useDefaultLetterhead: true,
  isHeaderCropped: false,
  isFooterCropped: false,
};

const reportConfigSlice = createSlice({
  name: "reportConfig",
  initialState,
  reducers: {
    updateBodySummary: (state, action) => {
      state.bodySummary = action.payload;
    },
    updateCoverPage: (state, action) => {
      state.coverPage = action.payload;
    },
    updateReportSummary: (state, action) => {
      state.reportSummary = action.payload;
    },
    updateTestRecommendation: (state, action) => {
      state.testRecommendation = action.payload;
    },

    updateVizApp: (state, action) => {
      state.vizApp = action.payload;
    },
    updateSmartVideoReport: (state, action) => {
      state.smartVideoReport = action.payload;
    },
    updatePrimaryColor: (state, action) => {
      state.primaryColor = action.payload;
    },
    updateReportType: (state, action) => {
      state.reportType = action.payload;
    },
    updateHeaderBase64: (state, action) => {
      state.headerBase64 = action.payload;
    },
    updateFooterBase64: (state, action) => {
      state.footerBase64 = action.payload;
    },
    updateLogoBase64: (state, action) => {
      state.logoBase64 = action.payload;
    },
    updateDoctorSignBase64: (state, action) => {
      state.doctorSignBase64 = action.payload;
    },
    updateLogoFileName: (state, action) => {
      state.logoFileName = action.payload;
    },
    updateLetterHeadFileName: (state, action) => {
      state.letterHeadFileName = action.payload;
    },
    updateDoctorSignFileName: (state, action) => {
      state.doctorSignFileName = action.payload;
    },
    updateUseDefaultLetterhead: (state, action) => {
      state.useDefaultLetterhead = action.payload;
    },
    updateIsHeaderCropped: (state, action) => {
      state.isHeaderCropped = action.payload;
    },
    updateIsFooterCropped: (state, action) => {
      state.isFooterCropped = action.payload;
    },
  },
});

export default reportConfigSlice.reducer;
export const {
  updateBodySummary,
  updateCoverPage,
  updateReportSummary,
  updateTestRecommendation,
  updateVizApp,
  updateSmartVideoReport,
  updatePrimaryColor,
  updateReportType,
  updateHeaderBase64,
  updateFooterBase64,
  updateLogoBase64,
  updateDoctorSignBase64,
  updateLogoFileName,
  updateLetterHeadFileName,
  updateDoctorSignFileName,
  updateUseDefaultLetterhead,
  updateIsHeaderCropped,
  updateIsFooterCropped,
} = reportConfigSlice.actions;
